import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../utils/api";

// What the site shows until /settings answers — and the shape the admin form
// writes back. Seeded with the group's real details so a cold load, or a
// settings record that predates a field, still renders correctly.
const DEFAULTS = {
  org_name: "Innovative Waste Management Research Group",
  org_short_name: "IWM Research Group",
  tagline: "",
  email: "iwm@dal.ca",
  phone: "",
  address_line1: "Cox Institute",
  address_line2: "Faculty of Agriculture",
  city: "Truro",
  region: "NS",
  postal_code: "",
  country: "",
  office_hours: "",
  affiliation: "Dalhousie University",
  scholar_url: "",
  orcid_url: "",
  // Dr. Gordon Price. Drives the live publication feed on /publications;
  // clearing it falls the page back to the curated list alone.
  orcid_id: "0000-0002-8621-1444",
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {}, updateSettings: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch {
      /* keep defaults */
    }
  }, []);

  const updateSettings = useCallback(async (patch) => {
    const { data } = await api.put("/admin/settings", patch);
    setSettings({ ...DEFAULTS, ...data });
    return data;
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export function formatAddress(s, { joiner = ", " } = {}) {
  if (!s) return "";
  return [s.address_line1, s.address_line2, [s.city, s.region].filter(Boolean).join(", "), [s.postal_code, s.country].filter(Boolean).join(" · ")]
    .filter(Boolean).join(joiner);
}

export function locationShort(s) {
  if (!s) return "";
  return [s.city, s.region, s.country].filter(Boolean).join(" · ");
}
